import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ShippingFreightFlatTeamSettingGroupId =
  | "shipping_freight.freight_pickup_windows"
  | "shipping_freight.freight_handling_units"
  | "shipping_freight.freight_pickup_accessorials"
  | "shipping_freight.freight_delivery_accessorials";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason: "Freight pickup windows, handling units, and accessorial presets.",
};

export const ShippingFreightFlatTeamSettingGroups = [
  {
    id: "shipping_freight.freight_pickup_windows",
    title: "Freight pickup windows",
    description:
      "The time windows carriers may collect freight shipments from your locations.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "freight" },
    synonyms: ["freight pickup windows", "shipping freight"],
  },
  {
    id: "shipping_freight.freight_handling_units",
    title: "Freight handling units",
    description:
      "The handling unit types available when building a freight shipment.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "freight" },
    synonyms: ["freight handling units", "shipping freight"],
  },
  {
    id: "shipping_freight.freight_pickup_accessorials",
    title: "Freight pickup accessorials",
    description:
      "Reusable sets of accessorial services applied when freight is picked up.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "freight" },
    synonyms: ["freight pickup accessorials", "shipping freight"],
  },
  {
    id: "shipping_freight.freight_delivery_accessorials",
    title: "Freight delivery accessorials",
    description:
      "Reusable sets of accessorial services applied when freight is delivered.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "freight" },
    synonyms: ["freight delivery accessorials", "shipping freight"],
  },
] as const satisfies readonly SettingGroupDefinition<ShippingFreightFlatTeamSettingGroupId>[];
